import axios from 'axios';
import { LOADING_AUTHOR, RECEIVED_AUTHOR, RECEIVED_AUTHOR_FAILED } from '../types';
import { createParameters, createUrl } from '../utils';
import { identificationType } from '../../constants';

export function loadingAuthor(dispatch, index) {
  return dispatch({ type: LOADING_AUTHOR, payload: { index } });
}

export function receivedAuthor(dispatch, index) {
  return ({ data }) => dispatch({
    type: RECEIVED_AUTHOR,
    payload: { index, data },
  });
}

export function receivedAuthorFailed(dispatch, index) {
  return () => dispatch({ type: RECEIVED_AUTHOR_FAILED, payload: { index } });
}

const urlFormatter = {
  [identificationType.pii]: ({ pii, token, index }) => `/enhancements/article/pii/${pii}/author/${index + 1}?token=${token}`,
  [identificationType.doi]: ({ doi, token, index }) => `/enhancements/article/doi/${doi}/author/${index + 1}?token=${token}`,
};

export default function fetchAuthor(index) {
  return (dispatch, getState) => {
    loadingAuthor(dispatch, index);
    const {
      idType,
      pdfContent: { identification },
      metadata,
      token,
    } = getState();
    const parameters = createParameters(idType, identification, metadata, token);
    const formatUrl = urlFormatter[idType];
    const url = formatUrl({ ...parameters, index });
    return axios.get(createUrl(url))
      .then(receivedAuthor(dispatch, index))
      .catch(receivedAuthorFailed(dispatch, index));
  };
}
